import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Modal,
  Row,
  Col,
  message,
} from 'antd';
import Login from 'views/Auth/Login';
import { postSolicitarCodigoDeAcceso } from 'api/auth';
import { handleLogout, selectTokenIsExpired, selectUser } from 'store/auth';
import { Text, Button, COLORS } from 'components';
import { useNavigate } from 'react-router';
import { Turnstile } from '@marsidev/react-turnstile';
import { siteKey } from 'utils/env';

const SessionExpiredModal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tokenIsExpired = useSelector(selectTokenIsExpired);
  const user = useSelector(selectUser);
  const [codeSent, setCodeSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState();

  useEffect(() => {
    if (!tokenIsExpired) {
      setCodeSent(false);
    }
  }, [tokenIsExpired]);

  const sendCode = async () => {
    setLoading(true);
    const response = await postSolicitarCodigoDeAcceso({ ...user, cf_turnstile_token: token });
    if (!response.error) {
      setCodeSent(true);
    } else if (response.detail) {
      message.warning(response.detail);
    }
    setLoading(false);
  };

  const logout = () => {
    dispatch(handleLogout());
    setTimeout(() => navigate('/'));
  };

  return (
    <Modal
      visible={tokenIsExpired}
      title="Sesión expirada"
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={null}
      destroyOnClose
    >
      {codeSent ? (
        <Login modal />
      ) : (
        <>
          <Text>
            La sesión ha expirado.
            <br />
            Puede solicitar un código nuevo para continuar si lo desea.
          </Text>
          <Turnstile
            siteKey={siteKey}
            onSuccess={(cf_turnstile_token) => setToken(cf_turnstile_token)}
            onError={() => setToken(null)}
            onExpire={() => setToken(null)}
          />
          <Row justify="end" gutter={10} style={{ marginTop: 30 }}>
            <Col>
              <Button disabled={loading} onClick={logout} danger type="primary" color={COLORS.white}>
                <Text>
                  Cerrar sesión
                </Text>
              </Button>
            </Col>
            <Col>
              <Button disabled={loading || !token} onClick={sendCode} $accent>
                <Text>
                  Solicitar código
                </Text>
              </Button>
            </Col>
          </Row>
        </>
      )}
    </Modal>
  );
};

export default SessionExpiredModal;
